import { message } from 'antd'
import { useMutation, useQuery, useQueryClient } from 'react-query'

import {
  editNotificationPreference,
  editOptionNotification,
  getNotificationPreferences,
  getOptionNotification,
} from 'utils/apis'

export const useNotificationOptions = ({ options = {} }) => {
  return useQuery(
    ['notificationOptions'],
    async () => {
      const {
        data: { data },
      } = await getOptionNotification()
      return data
    },
    {
      onError: (error) =>
        message.error(error?.data?.message || 'Failed to load notification settings from server!'),
      ...options,
    },
  )
}

export const useEditNotificationOptionMutation = () => {
  return useMutation(({ name, value }) => editOptionNotification(name, { value }))
}

export const useNotificationPreferences = ({ options = {} } = {}) => {
  return useQuery(
    ['notificationPreferences'],
    async () => {
      const {
        data: { data },
      } = await getNotificationPreferences()
      return data
    },
    {
      onError: (error) =>
        message.error(
          error?.data?.message || 'Failed to load notification preferences from server!',
        ),
      ...options,
    },
  )
}

export const useEditNotificationPreferenceMutation = () => {
  const queryClient = useQueryClient()

  return useMutation(
    ({ categorySlug, subscribed }) => editNotificationPreference(categorySlug, { subscribed }),
    {
      // Sinkronkan cache supaya nilai rollback saat error selalu yang terbaru
      onSuccess: (response) => {
        const updated = response?.data?.data
        if (!updated) {
          return
        }
        queryClient.setQueryData(['notificationPreferences'], (prev) =>
          (prev || []).map((item) =>
            item.category_slug === updated.category_slug ? { ...item, ...updated } : item,
          ),
        )
      },
    },
  )
}
